import React from 'react';
import { Icon } from '@iconify/react';
import ActionButton from '../../ActionButton';
import { Typography } from '@mui/material';


const DashboardHeader = ({ onRefresh, isDark, onToggleDarkMode, trailingAction = null }) => (
  <header className="reports-masthead space-y-2">
    <div className="reports-masthead-row flex justify-between items-center">
          <div className="reports-welcome">
          <Typography component="h1" variant="h4">Reports</Typography>
          <Typography variant="body3" className="reports-masthead-subtitle" sx={{ mt: 1 }}>Time-based analytics that default to the last 60 days in each location’s local timezone; use the date filters to view older available data.</Typography>
        </div>
      <div className="reports-header-actions flex flex-wrap items-center gap-4 shrink-0">
        <button
          onClick={onToggleDarkMode}
          className="relative w-12 h-5 bg-gray-300 dark:bg-gray-600 rounded-full flex items-center px-1 transition-colors duration-300"
          aria-label="Toggle dark mode"
          type="button"
          aria-pressed={isDark}
          title="Toggle dark mode"
        >
          <div
            className={`w-5 h-5 rounded-full bg-white shadow-md transform transition-transform duration-300 ${
              isDark ? 'translate-x-6' : 'translate-x-0'
            }`}
          />
          <span className="absolute left-1 text-xs">
            <Icon icon={isDark ? 'fluent-emoji:crescent-moon' : 'fluent-emoji:sun'} className="h-4 w-4" aria-hidden="true" />
          </span>
        </button>
        <ActionButton
          type="button"
          onClick={onRefresh}>
          Reset Data
        </ActionButton>
        {trailingAction}
      </div>
    </div>
  </header>
);

export default DashboardHeader;
